import { Dimensions, Platform } from 'react-native';
import getDeviceInfoSync from '../getDeviceInfoSync';
export default function isIphone() {
    if (Platform.OS === 'ios') {
        return true;
    }
    if (Platform.OS === 'web') {
        return /iP(hone|ad)/.test(window.navigator.userAgent);
    }
    return false;
}
export function isIphoneX() {
    const dimen = Dimensions.get('screen');
    return (isIphone() &&
        // @ts-ignore
        !Platform.isPad &&
        // @ts-ignore
        !Platform.isTVOS &&
        (dimen.height === 780 ||
            dimen.width === 780 ||
            dimen.height === 812 ||
            dimen.width === 812 ||
            dimen.height === 844 ||
            dimen.width === 844 ||
            dimen.height === 896 ||
            dimen.width === 896 ||
            dimen.height === 926 ||
            dimen.width === 926 ||
            dimen.height === 852 ||
            dimen.width === 852 ||
            dimen.height === 932 ||
            dimen.width === 932));
}
const checkDimensions = (portraitWidth, portraitHeight) => {
    const dimen = Dimensions.get('window');
    return ((dimen.height === portraitHeight && dimen.width === portraitWidth) ||
        (dimen.width === portraitHeight && dimen.height === portraitWidth));
};
// 12, 12 Pro, 13, 13 Pro and 12 Pro Max, 13 Pro Max
const _isStatusBarHeight47 = () => {
    return checkDimensions(390, 844) || checkDimensions(428, 926);
};
// 11, xr
const _isStatusBarHeight48 = () => {
    // 暂时无法用宽高来判断 11 和 xr，因为 11 和 11 pro max 也是这个尺寸
    if (!checkDimensions(414, 896)) {
        return false;
    }
    // const ret = NativeModules?.KRNBasic?.getDeviceInfoSync();
    const ret = getDeviceInfoSync();
    if (ret) {
        const model = ret.model;
        if (model === 'iPhone12,1' || model === 'iPhone11,8') {
            return true;
        }
    }
    return false;
};
// 12 Mini, 13 Mini
const _isStatusBarHeight50 = () => {
    return checkDimensions(360, 780) || checkDimensions(375, 812);
};
// 14 Pro, 14 Pro Max
const _isStatusBarHeight54 = () => {
    return checkDimensions(393, 852) || checkDimensions(430, 932);
};
export function _getIphoneStatusBarHeight() {
    if (isIphoneX()) {
        if (_isStatusBarHeight47()) {
            return 47;
        }
        if (_isStatusBarHeight48()) {
            return 48;
        }
        if (_isStatusBarHeight50()) {
            return 50;
        }
        if (_isStatusBarHeight54()) {
            return 54;
        }
        return 44;
    }
    return 20;
}
//灵动岛
export function isDynamicIsland() {
    return (Platform.OS === 'ios' &&
        !Platform.isPad &&
        !Platform.isTVOS &&
        _isStatusBarHeight54());
}
